<template>
  <div>
    <DataTable
      :value="activityStatuses"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedActivityStatuses"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityStatuses"
    >
      <template #empty> No statuses found. </template>
      <template #loading> Loading statuses data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="statusCode"
        header="Code"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.statusCode }}
          </div>
        </template>
      </Column>
      <Column
        field="statusName"
        header="Name"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.statusName }}
          </div>
        </template>
      </Column>
      <Column
        field="showsOn"
        header="Shows on"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ showsOnLabel(slotProps.data.showsOn) }}
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column
        field="colourCode"
        header="ColourCode"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.colourCode && slotProps.data.colourCode.label ? slotProps.data.colourCode.label : "" }}
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editActivityStatus(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import { showsOnLabel } from '../../activityKind.js'
import PermissionMixin from '../../PermissionMixin.vue'

export default {
  mixins: [PermissionMixin],
  props: [
    'activityStatuses',
    'loading'
  ],
  data: () => ({
    selectedActivityStatuses: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    showsOnLabel,
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteActivityStatus(data)
            }
          }
        )
      }
      return buttons
    },
    deleteActivityStatus(activityStatus) {
      
    },
    editActivityStatus(activityStatus) {
      this.$emit('edit-activity-status', activityStatus)
    }
  }
}
</script>

<style>

</style>